import config from 'config';
const axios = require('axios').default;
import storage from '@/cflow/storageService';

export const api = axios.create({
    baseURL: config[process.env.NODE_ENV].api.endpoint,
    timeout: 100000,
    headers: {
        'Authorization': 'Basic '+config[process.env.NODE_ENV].api.clientToken,
		'Content-Type': 'application/json'
    }
});

// Injeta token do usuário como header dedicado em todas as requisições autenticadas.
// Isso evita expor o token em query strings (visíveis em logs e histórico do browser).
// O header Authorization é reservado para o Basic app-token (AuthBasic middleware).
api.interceptors.request.use(function (requestConfig) {
    const token = storage.get('user', 'token');
    if (token) {
        requestConfig.headers['X-User-Token'] = token;
    }
    return requestConfig;
});

api.interceptors.response.use(response => {
    return response;
 }, error => {

   if (error.response.status === 401) {
    storage.clear('user');
    location.reload();
   }
   return error;
 });

export default api;
